import { UserMenuItem } from '@domain/models/auth/user-menu';
import { Subscription } from 'rxjs';

export abstract class SidebarRepository {
  abstract setStatus(isActive: boolean): void;
  abstract onStatusChanged(observer: (isActive: boolean) => void): Subscription;
  abstract inactivateAllItems(items: Array<UserMenuItem>): void;
}
